export interface PlotMargins {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

export const getPlotMargins = (uiScale: number): PlotMargins => {
  const RIGHT_AXIS_WIDTH = Math.max(50, Math.round(70 * uiScale));

  return {
    top: Math.round(24 * uiScale),
    right: RIGHT_AXIS_WIDTH,
    bottom: Math.round(80 * uiScale),
    left: Math.round(75 * uiScale),
  };
};
